import { ArrowRight, ArrowUpRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 pb-16 lg:pt-44 lg:pb-24 border-b border-[#E4E4E7] overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-end">
        <div className="lg:col-span-7 keepsy-rise">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-2 h-2 bg-[#3FA742] inline-block" />
            <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0]">
              LinkedIn Brand + Client System · Finance Firms
            </p>
          </div>

          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl xl:text-[5.5rem] font-black tracking-tighter leading-[0.92] text-[#09090B]">
            New clients are<br />
            waiting for you on{" "}
            <span className="underline decoration-[#3FA742] decoration-[10px] underline-offset-[8px] decoration-clone">LinkedIn.</span>
          </h1>

          <p className="mt-7 max-w-xl text-lg text-[#52525B] leading-relaxed">
            Is your profile prepared and ready to take advantage of it? Our system is built for finance firms looking for more clients. This isn't magic — we don't promise overnight leads. We turn your profile into a reliable, trustworthy brand and connect you with companies actively using LinkedIn to find partners.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <a
              href="#contact"
              data-testid="hero-primary-cta"
              className="inline-flex items-center justify-center gap-2 bg-[#09090B] text-white font-bold px-6 py-4 hover:bg-[#1F4DA0] transition-colors group"
            >
              Audit my LinkedIn — free
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#how"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#09090B] text-[#09090B] font-bold px-6 py-4 hover:bg-[#09090B] hover:text-white transition-colors"
            >
              See the system
              <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "90d", v: "Typical time to a fully built brand" },
              { k: "11x", v: "Avg. ROI once the system runs" },
              { k: "100%", v: "Done with you, not behind your back" },
            ].map((s) => (
              <div key={s.k} data-testid={`hero-stat-${s.k}`}>
                <p className="font-display font-black text-3xl tracking-tighter text-[#09090B]">{s.k}</p>
                <p className="text-xs text-[#52525B] mt-1 leading-tight">{s.v}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full border border-[#09090B] overflow-hidden bg-[#09090B]">
            <img
              src="https://images.unsplash.com/photo-1647513600981-95ad864195d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZSUyMGJsYWNrJTIwYW5kJTIwd2hpdGV8ZW58MHx8fHwxNzc4Njg2OTM4fDA&ixlib=rb-4.1.0&q=85"
              alt="Abstract structural architecture"
              className="w-full h-full object-cover grayscale contrast-125"
              loading="eager"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-white p-5 border-t border-[#09090B]">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#52525B]">LinkedIn DM · Inbound reply</p>
              <p className="font-display font-bold text-[#09090B] mt-1 leading-tight">
                "Saw your post — we've been looking for a bookkeeper. Can we talk?"
              </p>
            </div>
            <div className="absolute -top-3 -right-3 bg-[#3FA742] text-white font-mono text-[10px] uppercase tracking-widest px-3 py-1.5">
              Live
            </div>
          </div>

          <div className="hidden lg:block absolute -left-12 -bottom-8 bg-white border border-[#09090B] p-4 w-56 shadow-[6px_6px_0_0_#09090B]">
            <p className="font-mono text-[10px] uppercase tracking-widest text-[#1F4DA0]">New connection</p>
            <p className="font-display font-bold text-sm mt-1 text-[#09090B]">Sarah M. · Plumbing co.</p>
            <p className="text-xs text-[#52525B] mt-1">$640K rev · QuickBooks · DM'd back in 2h</p>
          </div>
        </div>
      </div>
    </section>
  );
}
